import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  HomeDbState,
  Announcement,
  UserSuggestion,
  Suggestion,
  Testimonial,
  Category,
} from "../../interfaces/AdminObject";
import AdminThunk from "../../services/thunks/AdminThunk";
import { resetAllState } from "./resetAllState";

const initialState: HomeDbState = {
  announcements: [
    {
      title: "System Maintenance",
      description: "The system will be under maintenance.",
      startDate: "2025-10-04T10:00:00Z",
      endDate: "2025-10-04T14:00:00Z",
    },
    {
      title: "New Feature Release",
      description: "We're launching the new dashboard view next week.",
      startDate: "2025-10-10T08:00:00Z",
      endDate: "2025-10-10T12:00:00Z",
    },
  ],
  currentUserSuggestion: {
    feedback: "This is my feedback about the product.",
  },
  allSuggestions: [],
  testimonials: [
    {
      userId: "a1b2c3d4",
      quote: "This platform transformed our workflow!",
      author: "Alex Johnson",
    },
    {
      userId: "e5f6g7h8",
      quote: "Exceptional support and intuitive design.",
      author: "Maria Lopez",
    },
  ],
  categories: [
    {
      categoryName: "electronics",
      categoryImage: "https://example.com/images/electronics.jpg",
    },
    {
      categoryName: "fashion",
      categoryImage: "https://example.com/images/fashion.jpg",
    },
  ],
};

// const initialState: HomeDbState = {
//   announcements: [],
//   currentUserSuggestion: { feedback: "" },
//   allSuggestions: [],
//   testimonials: [],
//   categories: [],
// };

const homeDbSlice = createSlice({
  name: "homeDb",
  initialState,
  reducers: {
    setAnnouncements(state, action: PayloadAction<Announcement[]>) {
      state.announcements = action.payload;
    },
    addAnnouncement(state, action: PayloadAction<Announcement>) {
      state.announcements.push(action.payload);
    },
    setCurrentUserSuggestion(state, action: PayloadAction<UserSuggestion>) {
      state.currentUserSuggestion = action.payload;
    },
    setAllSuggestions(state, action: PayloadAction<Suggestion[]>) {
      state.allSuggestions = action.payload;
    },
    addSuggestion(state, action: PayloadAction<Suggestion>) {
      state.allSuggestions.push(action.payload);
    },
    setTestimonials(state, action: PayloadAction<Testimonial[]>) {
      state.testimonials = action.payload;
    },
    addTestimonial(state, action: PayloadAction<Testimonial>) {
      state.testimonials.push(action.payload);
    },
    setCategories(state, action: PayloadAction<Category[]>) {
      state.categories = action.payload;
    },
    addCategory(state, action: PayloadAction<Category>) {
      state.categories.push(action.payload);
    },
    resetHomeDbState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AdminThunk.fetchAllFeedbacks.pending, (state: any) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(
        AdminThunk.fetchAllFeedbacks.fulfilled,
        (state: any, action: any) => {
          state.loading = false;
          state.success = true;
          state.allSuggestions = action.payload as any; // Update the state with the fetched data
          // setAllSuggestions(action.payload);
        },
      )
      .addCase(
        AdminThunk.fetchAllFeedbacks.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.error = action.payload; // Store the error message
          state.success = false;
        },
      )
      .addCase(resetAllState, () => initialState)
      .addCase(AdminThunk.fetchAnnouncements.pending, (state: any) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        AdminThunk.fetchAnnouncements.fulfilled,
        (state: any, action: any) => {
          state.loading = false;
          state.announcements = action.payload;
        }
      )
      .addCase(
        AdminThunk.fetchAnnouncements.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.error = action.payload;
        }
      );
  },
});

export const {
  setAnnouncements,
  addAnnouncement,
  setCurrentUserSuggestion,
  setAllSuggestions,
  addSuggestion,
  setTestimonials,
  addTestimonial,
  setCategories,
  addCategory,
  resetHomeDbState,
} = homeDbSlice.actions;

export default homeDbSlice.reducer;
